<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de Cierre de Comisiones</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button @click="consultar" type="button" class="btn-info btn--bigger">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
          <button @click="exportarExcel" type="button" class="btn-success btn--bigger">
            <i class="fa fa-file-excel-o"></i>
            <span>Excel</span>
          </button>
          <button @click="cerrar" type="button" class="btn-primary btn--bigger">
            <i class="fa fa-times"></i>
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Filtros de consulta</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-inline">
              <label for="hoy">
                <input v-model="form.tipo_fecha" type="radio" name="tipo_fecha" id="hoy" value="H" />
                <span>Hoy</span>
              </label>
              <label for="ayer">
                <input v-model="form.tipo_fecha" type="radio" name="tipo_fecha" id="ayer" value="A" />
                <span>Ayer</span>
              </label>
              <label for="personalizado">
                <input
                  v-model="form.tipo_fecha"
                  type="radio"
                  name="tipo_fecha"
                  id="personalizado"
                  value="P"
                />
                <span>Personalizado</span>
              </label>
              <div class="form-field">
                <div class="datepicker-field">
                  <VueCtkDateTimePicker
                    :disabled="form.tipo_fecha !== 'P'"
                    id="desde"
                    v-model="form.desde"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.desde[0] }}</strong>
                  </span>
                </div>
              </div>
              <div class="form-field">
                <div class="datepicker-field">
                  <VueCtkDateTimePicker
                    :disabled="form.tipo_fecha !== 'P'"
                    id="hasta"
                    v-model="form.hasta"
                    locale="es"
                    no-label
                    only-date
                    auto-close
                    button-now-translation="Ahora"
                    format="YYYY-MM-DD"
                    formatted="YYYY-MM-DD"
                    label="Seleccione una fecha..."
                  />
                  <label>Hasta</label>
                  <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.hasta[0] }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Resultados de la consulta</h5>
      </div>
      <div class="card__content">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Fecha de conciliación</th>
                <th>Observación</th>
                <th>Usuario de cierre</th>
                <th>Vendedor</th>
                <th>Total de margen</th>
                <th>Saldo</th>
                <th>Total de comisión</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(conciliacion, index) in conciliaciones" :key="index">
                <td>{{ conciliacion.fecha_conciliacion }}</td>
                <td>{{ conciliacion.observacion }}</td>
                <td>{{ conciliacion.nombre_usuario_cierre }}</td>
                <td>{{ conciliacion.nombre_vendedor }}</td>
                <td>{{ moneyFormat(conciliacion.total_margenes) }}</td>
                <td>{{ moneyFormat(conciliacion.saldo_pendiente) }}</td>
                <td>{{ moneyFormat(conciliacion.total_comision) }}</td>
                <td>
                  <button
                    @click="anularCierre(conciliacion)"
                    type="button"
                    class="btn-danger btn--text"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="conciliaciones.length === 0">
                <td colspan="9">
                  <strong>No se ha encontrado resultados.</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card mt-2">
      <div class="card__title">
        <h5>Totales</h5>
      </div>
      <div class="card__content">
        <div class="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Margen total</th>
                <th>Saldo total</th>
                <th>Comisión total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ moneyFormat(margenTotal) }}</td>
                <td>{{ moneyFormat(saldoTotal) }}</td>
                <td>{{ moneyFormat(comisionTotal) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      form: {
        tipo_fecha: "P",
        desde: "",
        hasta: "",
        exportar: "N"
      },
      errores: {},
      conciliaciones: [],
      moneyFormat: moneyFormat
    };
  },
  computed: {
    margenTotal: function() {
      let margenTotal = 0;
      for (let i = 0; i < this.conciliaciones.length; i++)
        margenTotal += parseFloat(this.conciliaciones[i].total_margenes);
      return round(margenTotal);
    },
    saldoTotal: function() {
      let saldo_pendiente = 0;
      for (let i = 0; i < this.conciliaciones.length; i++)
        saldo_pendiente += parseFloat(this.conciliaciones[i].saldo_pendiente);
      return round(saldo_pendiente);
    },
    comisionTotal: function() {
      let total_comision = 0;
      for (let i = 0; i < this.conciliaciones.length; i++)
        total_comision += parseFloat(this.conciliaciones[i].total_comision);
      return round(total_comision);
    }
  },
  methods: {
    toParams: function(data) {
      return Object.keys(data)
        .map(key => `${key}=${encodeURIComponent(data[key])}`)
        .join("&");
    },
    exportarExcel: function() {
      this.form.exportar = "E";
      let params = this.toParams(this.form);
      window.open(url + "/cierre-comisiones?" + params, "_blank");
    },
    anularCierre: function(conciliacion) {
      let that = this;
      swal({
        title: "¿Desea anular el cierre de conciliación seleccionado?",
        text:
          "Los saldos y comprobantes serán restablecidos a su estado antes del cierre.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Anular",
        cancelButtonText: "No"
      }).then(function(result) {
        if (result.value) {
          axios
            .post(url + "/cierre-comisiones/" + conciliacion.conciliacion_id, {
              vendedor_id: conciliacion.vendedor_id,
              _method: "DELETE"
            })
            .then(function() {
              swal("El cierre ha sido anulado.", "Realizado", "success");
              that.consultar();
            })
            .catch(function() {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    consultar: function() {
      let that = this;
      that.form.exportar = "N";
      axios
        .get(url + "/cierre-comisiones", {
          params: this.form
        })
        .then(function(response) {
          that.conciliaciones = response.data;
        })
        .catch(function(error) {
          if (error && error.response) {
            let response = error.response;
            let status = response.status;
            if (status == 422) {
              that.errores = response.data.errors;
              swal("El formulario posee errores.", "Aviso", "warning");
              return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Aviso", "error");
        });
    },
    cerrar: function() {
      location.href = url + "/cierre-comisiones/create";
    },
    changePersonalizado: function() {
      this.form.hasta = moment(new Date()).format("YYYY-MM-DD");
      let desde = new Date();
      desde.setDate(desde.getDate() - 7);
      this.form.desde = moment(desde).format("YYYY-MM-DD");
    }
  },
  mounted: function() {
    this.changePersonalizado();
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/cierre-comisiones/ConsultaCierreComisiones.vue